
import { computed, defineComponent, PropType, reactive } from 'vue'

// components
import ButtonDropdown from '@/common/components/UI/ButtonDropdown/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// realisation
import { cities } from '@/core/realisations/cities.realisation'

// types
import { CityListItemT } from '@/core/types/cities.types'

// composable
import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: { ButtonDropdown, TheButton },
    props: {
        city: {
            type: Object as PropType<CityListItemT>,
            required: true,
        },
    },
    emits: ['reload', 'delete'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
        })

        const manageAviaAction = async () => {
            if (!props.city) return

            try {
                state.is_loading = true

                if (props.city.aviaEnabled) {
                    await cities.disableAvia(props.city.id)
                } else {
                    await cities.enableAvia(props.city.id)
                }

                emit('reload')
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: `Произошла ошибка`,
                })
            } finally {
                state.is_loading = false
            }
        }

        const onDelete = () => {
            emit('delete', { ...props.city })
        }

        const getAviaTxt = computed(() =>
            props.city && props.city.aviaEnabled ? 'Выключить авиа' : 'Включить авиа'
        )

        return {
            state,
            //
            manageAviaAction,
            onDelete,
            //
            getAviaTxt,
        }
    },
})
